import React from 'react';
import cn from 'classnames';

import styles from './SearchFilterModal.module.postcss';

// These category slugs are treated as dietary options in the modal
const DIETARY_SLUGS = new Set(['vegetarian', 'vegan', 'gluten-free', 'halal', 'kosher']);

function SearchFilterModal({ isOpen, onClose, foodCategories, selected, onChange }) {
  if (!isOpen) return null;

  const selectedIds = (selected || []).map((c) => c.id);

  const dietaryCategories = foodCategories.filter((c) => DIETARY_SLUGS.has(c.id));
  const cuisineCategories = foodCategories.filter((c) => !DIETARY_SLUGS.has(c.id));

  const toggle = (category) => {
    if (selectedIds.includes(category.id)) {
      onChange((selected || []).filter((c) => c.id !== category.id));
    } else {
      onChange([...(selected || []), category]);
    }
  };

  return (
    <div className={styles.FilterModal_Backdrop} onClick={onClose}>
      <div className={cn(styles.FilterModal, { [styles.FilterModal__open]: isOpen })} onClick={(e) => e.stopPropagation()}>
        <div className={styles.FilterModal_Header}>
          <span className={styles.FilterModal_Title}>Filters</span>
          <button type='button' className={styles.FilterModal_Close} onClick={onClose} aria-label='Close'>
            ×
          </button>
        </div>

        <div className={styles.FilterModal_Body}>
          {dietaryCategories.length > 0 && (
            <section className={styles.FilterModal_Section}>
              <h3 className={styles.FilterModal_SectionTitle}>Dietary</h3>
              <div className={styles.FilterModal_Pills}>
                {dietaryCategories.map((cat) => {
                  const checked = selectedIds.includes(cat.id);
                  return (
                    <button
                      key={cat.id}
                      type='button'
                      className={cn(styles.FilterModal_Pill, { [styles.FilterModal_Pill__checked]: checked })}
                      onClick={() => toggle(cat)}
                      aria-pressed={checked}
                    >
                      {checked && (
                        <svg width='10' height='8' viewBox='0 0 10 8' fill='none' aria-hidden='true'>
                          <path d='M1 4l3 3 5-6' stroke='currentColor' strokeWidth='1.75' strokeLinecap='round' strokeLinejoin='round'/>
                        </svg>
                      )}
                      {cat.name}
                    </button>
                  );
                })}
              </div>
            </section>
          )}

          <section className={styles.FilterModal_Section}>
            <h3 className={styles.FilterModal_SectionTitle}>Cuisine</h3>
            <div className={styles.FilterModal_Pills}>
              {cuisineCategories.map((cat) => {
                const checked = selectedIds.includes(cat.id);
                return (
                  <button
                    key={cat.id}
                    type='button'
                    className={cn(styles.FilterModal_Pill, { [styles.FilterModal_Pill__checked]: checked })}
                    onClick={() => toggle(cat)}
                    aria-pressed={checked}
                  >
                    {checked && (
                      <svg width='10' height='8' viewBox='0 0 10 8' fill='none' aria-hidden='true'>
                        <path d='M1 4l3 3 5-6' stroke='currentColor' strokeWidth='1.75' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    )}
                    {cat.name}
                  </button>
                );
              })}
            </div>
          </section>
        </div>

        <div className={styles.FilterModal_Footer}>
          <button
            type='button'
            className={styles.FilterModal_Clear}
            onClick={() => onChange([])}
          >
            Clear all
          </button>
          <button
            type='button'
            className={styles.FilterModal_Apply}
            onClick={onClose}
          >
            Show results
          </button>
        </div>
      </div>
    </div>
  );
}

export default SearchFilterModal;
